import { createComponent } from '@mtfe/sweet';
import { SearchResult } from '@mtfe/sweet-components';
import tpl from './dom.html';
import style from './style.less';

import { renderPoiInfoInSearch } from '../../utils/renderPoi';
import { fetchDataList } from '../../utils/fetchData';
import scrollLoading from '../../utils/scrollLoading';
import http from '../../service';
import store from '../../store';

const { storeCommon } = store;

const Result = async () => {
    const { structInfo } = storeCommon;
    const { dom_wm_search: domWmSearch, dom_wm_recommend: domWmRecommend } = structInfo.struct;

    const storeWmSearch = store[domWmSearch.recallBizId];
    const storeWmRecommend = store[domWmRecommend.recallBizId];

    const data = {
        renderResult: await SearchResult({
            renderPoiFunc: renderPoiInfoInSearch,
            http,
            scrollLoading,
            listInfoResult: storeWmSearch.poiData,
            listInfoRecommend: storeWmRecommend.poiData,
            // adapter function
            fetchDataList: ({ listInfo }) => fetchDataList(listInfo),
        }),
    };
    const events = {};
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

export default Result;
